import { GWidget } from "./GWidget";
import { Point } from "../maths/Point";
import { Event } from "../events/Event";
const MIN_GRIP_SIZE = 20;
export class GScrollBar extends GWidget {
    constructor() {
        super();
        this._scrollPerc = 0;
        this._fixedGripSize = false;
        this._dragOffset = new Point();
        this.on(Event.MOUSE_DOWN, this, this._barTouchBegin);
    }
    setOwner(target, vertical) {
        this._target = target;
        this._vertical = vertical;
    }
    setDisplayPerc(value) {
        if (this._vertical) {
            if (!this._fixedGripSize)
                this._gripButton.height = Math.max(Math.floor(value * this._bar.height), Math.min(MIN_GRIP_SIZE, this._bar.height));
            this._gripButton.y = this._bar.y + (this._bar.height - this._gripButton.height) * this._scrollPerc;
        }
        else {
            if (!this._fixedGripSize)
                this._gripButton.width = Math.max(Math.floor(value * this._bar.width), Math.min(MIN_GRIP_SIZE, this._bar.width));
            this._gripButton.x = this._bar.x + (this._bar.width - this._gripButton.width) * this._scrollPerc;
        }
        this._gripButton.visible = value != 0 && value != 1;
    }
    setScrollPerc(val) {
        this._scrollPerc = val;
        if (this._vertical)
            this._gripButton.y = this._bar.y + (this._bar.height - this._gripButton.height) * this._scrollPerc;
        else
            this._gripButton.x = this._bar.x + (this._bar.width - this._gripButton.width) * this._scrollPerc;
    }
    get minSize() {
        if (this._vertical)
            return (this._arrowButton1 ? this._arrowButton1.height : 0) + (this._arrowButton2 ? this._arrowButton2.height : 0);
        else
            return (this._arrowButton1 ? this._arrowButton1.width : 0) + (this._arrowButton2 ? this._arrowButton2.width : 0);
    }
    get gripDragging() {
        return this._gripDragging;
    }
    get fixedGripSize() {
        return this._fixedGripSize;
    }
    set fixedGripSize(value) {
        this._fixedGripSize = value;
    }
    _onConstruct(inPrefab) {
        if (this._gripButton) {
            this._gripButton.on(Event.MOUSE_DOWN, this, this._gripTouchBegin);
            this._gripButton.on(Event.MOUSE_DRAG, this, this._gripTouchMove);
            this._gripButton.on(Event.MOUSE_UP, this, this._gripTouchEnd);
        }
        if (this._arrowButton1)
            this._arrowButton1.on(Event.MOUSE_DOWN, this, this._arrowButton1Click);
        if (this._arrowButton2)
            this._arrowButton2.on(Event.MOUSE_DOWN, this, this._arrowButton2Click);
        super._onConstruct(inPrefab);
    }
    _gripTouchBegin(evt) {
        if (!this._bar || !this._target)
            return;
        evt.stopPropagation();
        this._gripDragging = true;
        this._target._updateScrollBarVisible();
        this.globalToLocal(this._dragOffset.copy(evt.touchPos));
        this._dragOffset.x -= this._gripButton.x;
        this._dragOffset.y -= this._gripButton.y;
    }
    _gripTouchMove(evt) {
        if (!this.displayedInStage || !this._target)
            return;
        let pt = this.globalToLocal(s_vec2.copy(evt.touchPos));
        if (this._vertical) {
            let curY = pt.y - this._dragOffset.y;
            let diff = this._bar.height - this._gripButton.height;
            if (diff == 0)
                this._target.percY = 0;
            else
                this._target.percY = (curY - this._bar.y) / diff;
        }
        else {
            let curX = pt.x - this._dragOffset.x;
            let diff = this._bar.width - this._gripButton.width;
            if (diff == 0)
                this._target.percX = 0;
            else
                this._target.percX = (curX - this._bar.x) / (this._bar.width - this._gripButton.width);
        }
    }
    _gripTouchEnd(evt) {
        if (!this._target)
            return;
        this._gripDragging = false;
        this._target._updateScrollBarVisible();
    }
    _arrowButton1Click(evt) {
        evt.stopPropagation();
        if (!this._target)
            return;
        if (this._vertical)
            this._target.scrollUp();
        else
            this._target.scrollLeft();
    }
    _arrowButton2Click(evt) {
        evt.stopPropagation();
        if (!this._target)
            return;
        if (this._vertical)
            this._target.scrollDown();
        else
            this._target.scrollRight();
    }
    _barTouchBegin(evt) {
        evt.stopPropagation();
        if (!this._target)
            return;
        let pt = this._gripButton.globalToLocal(s_vec2.copy(evt.touchPos));
        if (this._vertical) {
            if (pt.y < 0)
                this._target.scrollUp(4);
            else
                this._target.scrollDown(4);
        }
        else {
            if (pt.x < 0)
                this._target.scrollLeft(4);
            else
                this._target.scrollRight(4);
        }
    }
}
const s_vec2 = new Point();
